/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeDocumentControllerUpdateRequest { 
    name?: string;
    description?: string;
    keywords?: string;
    ownerUserId?: number;
    restricted?: boolean;
    allowDownload?: boolean;
    /**
     * Mover el documento de área recalcula su código
     */
    areaId?: string;
    /**
     * Cambiar el tipo recalcula su código
     */
    typeId?: string;
    /**
     * Consecutivo nuevo. Tiene que estar libre entre los documentos activos
     */
    sequence?: number;
}

